export default {"src":"/_next/static/media/strudel.13814c22.svg","height":681,"width":681,"blurWidth":0,"blurHeight":0};